<script>
import default_img from "@img/defaults/product-not-found.webp";
import SpinnerIndicator from "@js/components/Statuses/SpinnerIndicator.vue";

export default {
    name: "ImageLoader",
    components: {SpinnerIndicator},
    props: {
        title: {
            required: true,
            type: String,
        },
        src: {
            type: String,
        },
        imgClasses: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            imageLoaded: false,
        }
    },
    methods: {
        onImageLoad() {
            this.imageLoaded = true;
        },
        replaceByDefaultImg(event) {
            event.target.src = '/assets/defaults/product-not-found.webp';
        },
    },
    setup() {
        return {default_img}
    }
}
</script>

<template>
    <img :src="src ? src : default_img"
         :alt="title" :title="title"
         :class="[imageLoaded ? '' : 'img-loading', imgClasses]"
         @load="onImageLoad"
         @error="replaceByDefaultImg"/>
    <div v-if="!imageLoaded" class="flex flex-wrap items-center justify-center h-full">
        <SpinnerIndicator class="w-5 h-5 ms-2"/>
    </div>
</template>

<style scoped lang="scss">
.img-loading {
    max-width: 0 !important;
    max-height: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    position: absolute !important;
}
</style>
